import firebase from 'firebase'
import 'firebase/database'
import 'firebase/storage'

import { firebaseConfig } from '../brand'

firebase.initializeApp(firebaseConfig)

export default firebase
